/**
 * Lightweight parameter contract for the WebGL grass field.
 *
 * Kept separate from GrassScene so that pages, the settings panel and the
 * route chunks can reference the types and defaults without pulling the
 * heavy three.js scene into the initial bundle.
 */

export type GrassParams = {
  bladeCount: number;
  bladeHeight: number;
  bladeWidth: number;
  windStrength: number;
  windSpeed: number;
  mouseRadius: number;
  fogDensity: number;
  fieldSize: number;
  stage: number;
};

export const DEFAULT_PARAMS: GrassParams = {
  bladeCount: 40000,
  bladeHeight: 1.2,
  bladeWidth: 0.06,
  windStrength: 0.45,
  windSpeed: 0.9,
  mouseRadius: 2.2,
  fogDensity: 0.018,
  fieldSize: 60,
  stage: 0,
};